
// //addToCartBundle
// //variant id 43351881285676
// //selling plan id 1176436780
// //TRIALBUNDLEOFFERKIT
//   function isItemAlreadyAdded(variantId, sellingPlanId) {
//     const key = `addedToCart_${variantId}_${sellingPlanId}`;
//     return localStorage.getItem(key) === 'true';
//   }

//   function markItemAsAdded(variantId, sellingPlanId) {
//     const key = `addedToCart_${variantId}_${sellingPlanId}`;
//     localStorage.setItem(key, 'true');
//   }

//   function removeItemFromLocalStorage(variantId, sellingPlanId) {
//     const key = `addedToCart_${variantId}_${sellingPlanId}`;
//     localStorage.removeItem(key);
//   }

//   function addToCartAndCheckout(variantId, sellingPlanId) {
//     if (!isItemAlreadyAdded(variantId, sellingPlanId)) {
//       fetch('/cart/add.js', {
//         method: 'POST',
//         headers: {
//           'Content-Type': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({
//           items: [{
//             id: variantId,
//             quantity: 1,  
//             selling_plan: sellingPlanId
//           }]
//         })
//       })
//       .then(response => response.json())
//       .then(data => {
//         markItemAsAdded(variantId, sellingPlanId);
//         window.location.href = '/checkout';
//       })
//       .catch((error) => {
//         console.error('Error:', error);
//       });
//     } else {
//       alert('This item is already in your cart.');
//     }
//   }

//   document.addEventListener('DOMContentLoaded', function() {
//     const button = document.getElementById('addToCartBundle');
    
//     button.addEventListener('click', function(event) {
//         event.preventDefault(); 
//       const variantId = '43351881285676';
//       const sellingPlanId = '1176436780';
      
//       addToCartAndCheckout(variantId, sellingPlanId);
//     });
    
//     window.addEventListener('cart:removed', function(event) {
//       const variantId = event.detail.id;
//       const sellingPlanId = event.detail.selling_plan;
      
//       removeItemFromLocalStorage(variantId, sellingPlanId);
//     });
//   });
$(document).ready(function () { 
  $("#vid-modal1").on("show.bs.modal", function () {
        $("#js-video")[0].play();
    });
  $("#vid-modal1").on("hide.bs.modal", function () {
      $("#js-video")[0].pause();
  });
});